import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground shadow-xs hover:bg-primary/90',
        destructive: 'text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/40 bg-destructive/60',
        // `hover:bg-accent` was inherited from shadcn, where `accent` is a
        // NEUTRAL hover surface. Here `accent` is saturated brass, so these two
        // variants flashed gold on every hover — brass is reserved for
        // consequence (prices, the chosen tier), never for a hover state.
        // Superseded by `bg-input/50` in `outline` anyway; `ghost` genuinely
        // painted gold.
        outline: 'border shadow-xs bg-input/30 border-input hover:bg-surface-raised hover:border-border-strong',
        secondary: 'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
        ghost: 'hover:bg-surface-raised',
        link: 'text-primary underline-offset-4 hover:underline',
      },
      size: {
        default: 'h-9 px-4 py-2 has-[>svg]:px-3',
        sm: 'h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5',
        lg: 'h-11 rounded-md px-6 py-2.5 has-[>svg]:px-4 text-base',
        icon: 'size-9',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)
